import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAGoSxuToEwznGKmEiGGsZFtqrW84FrOQQ",
  authDomain: "laser-treat.firebaseapp.com",
  projectId: "laser-treat",
  storageBucket: "laser-treat.appspot.com",
  messagingSenderId: "988218749568",
  appId: "1:988218749568:web:0d07f87fc68f4ab1dfec65",
  measurementId: "G-HRY23E4VCT",
};

const app = initializeApp(firebaseConfig);

// const analytics = getAnalytics(app);

export const authentication = getAuth(app);
